<template>
    <div>
        <zm-button type="primary" plain @click="showCreate" v-if="hasPermission">Create</zm-button>
        <zm-table :data="list" v-loading="loading">
            <zm-table-column label="Name" prop="name"></zm-table-column>
            <zm-table-column label="Channel Name" prop="notificationChannelName"></zm-table-column>
            <zm-table-column label="Subject" prop="notifySubject" show-overflow-tooltip></zm-table-column>
            <zm-table-column label="Content" prop="notifyContent" show-overflow-tooltip></zm-table-column>
            <zm-table-column label="Notice Period" prop="alertPeriod">
                <template slot-scope="scope">
                    {{ scope.row.alertPeriod }}{{ scope.row.timeUnit }}
                </template>
            </zm-table-column>
            <zm-table-column label="Enable" prop="enable" width="90px">
                <template slot-scope="scope">
                    <i :class="scope.row.enable ? 'zm-icon-ok' : 'zm-icon-close'"></i>
                </template>
            </zm-table-column>
            <zm-table-column width="160px" v-if="hasPermission">
                <template slot-scope="scope">
                    <zm-button type="icon" class="zm-icon-edit" @click="showEdit(scope.row)"></zm-button>
                    <zm-button size="small" class="btn-contain" type="icon" title="change status" :icon="scope.row.enable ? 'zm-icon-pause' : 'zm-icon-play'"
                    @click="changeStatus(scope.row)"></zm-button>
                    <zm-button type="icon" class="zm-icon-delete" @click="showDelete(scope.row.id)"></zm-button>
                </template>
            </zm-table-column>
        </zm-table>
        <div style="text-align: center" class="pagination-wrap">
            <zm-pagination @current-change="fetchData"
            @size-change="handleSizeChange"
                :current-page.sync="pageable.page" :page-size="pageable.size"
                layout="total, prev, pager, next, sizes"
                :page-sizes="[10, 20, 50, 100, 500, 1000]"
                :total="pageable.total">
            </zm-pagination>
        </div>
        <zm-dialog :visible.sync="visible" :title="form.title">
            <zm-form label-width="150px" label-position="left" :model="form" ref="form" :rules="rules">
                <zm-form-item prop="name">
                    <div slot="label">
                        <tip label="Name" id="notificationrule-name"></tip>
                    </div>
                    <zm-input v-model.trim="form.name" size="small"></zm-input>
                </zm-form-item>
                <zm-form-item label="notificationChannelId" prop="notificationChannelId">
                    <div slot="label">
                        <tip label="Channel" id="notificationrule-notificationChannelId"></tip>
                    </div>
                    <zm-select v-model="form.notificationChannelId" filterable clearable size="small" style="width: 100%">
                        <zm-option v-for="item in channelList" :key="item.id" :label="item.name" :value="item.id"></zm-option>
                    </zm-select>
                </zm-form-item>
                <div class="zm-form-item zm-form--label-left">
                    <label class="zm-form-item__label" style="width: 150px;">
                        <tip label="Receivers" id="notificationrule-notifyUsers"></tip>
                    </label>
                    <div style="margin-left: 100px;">
                        <zm-tag type=""
                            class="input-tag"
                            :key="tag"
                            v-for="tag in form.notifyUsers"
                            closable
                            :disable-transitions="false"
                            @close="handleClose(tag)">
                            {{ tag }}
                        </zm-tag>
                        <zm-input
                            class="input-new-tag"
                            v-if="tagVisible"
                            v-model="tagInput"
                            ref="saveTagInput"
                            size="small"
                            @keyup.enter.native="handleInputConfirm()"
                            @blur="handleInputConfirm()"
                            >
                        </zm-input>
                        <zm-button size="small" v-else class="button-new-tag" @click="showInput()">+</zm-button>
                    </div>
                </div>
                <zm-form-item label="Receivers">
                    <div slot="label">
                        <tip label="Receivers Option" id="notificationrule-defaultNotifyUsers"></tip>
                    </div>
                    <zm-checkbox-group v-model="receiverOption" size="small">
                        <zm-checkbox v-for="item in receiverOptionList" :key="item" :label="item"></zm-checkbox>
                    </zm-checkbox-group>
                </zm-form-item>
                <zm-form-item label="notifySubject">
                    <div slot="label">
                        <tip label="Subject" id="notificationrule-notifySubject"></tip>
                    </div>
                    <zm-input v-model="form.notifySubject" size="small"></zm-input>
                </zm-form-item>
                <zm-form-item label="notifyDescription">
                    <div slot="label">
                        <tip label="Description" id="notificationrule-notifyDescription"></tip>
                    </div>
                    <zm-input type="textarea" v-model="form.notifyDescription" size="small"></zm-input>
                </zm-form-item>
                <zm-form-item label="notifyContent">
                    <div slot="label">
                        <tip label="Content" id="notificationrule-notifyContent"></tip>
                    </div>
                    <zm-input type="textarea" v-model="form.notifyContent" size="small"></zm-input>
                </zm-form-item>
                <zm-form-item label="alertPeriod">
                    <div slot="label">
                        <tip label="Alert Period" id="notificationrule-alertPeriod"></tip>
                    </div>
                    <div style="width: 100%">
                        <zm-input-number size="small" v-model="form.alertPeriod" :min="0" class="number-with-select"></zm-input-number>
                        <zm-select size="small" v-model="form.timeUnit" class="select-with-number">
                                <zm-option value="SECONDS">SECONDS</zm-option>
                                <zm-option value="MINUTES">MINUTES</zm-option>
                                <zm-option value="HOURS">HOURS</zm-option>
                                <zm-option value="DAYS">DAYS</zm-option>
                            </zm-select>
                    </div>
                </zm-form-item>
                <zm-form-item label-width="0">
                    <zm-checkbox v-model="form.enable" size="small">
                        <tip label="enable" id="notificationrule-enable"></tip>
                    </zm-checkbox>
                </zm-form-item>
            </zm-form>
            <div slot="footer" class="dialog-footer">
                <zm-button size="small" @click="visible = false">Cancel</zm-button>
                <zm-button size="small" type="primary" @click="save" :loading="loading">Save</zm-button>
            </div>
        </zm-dialog>
    </div>
</template>
<script>
import {
    listNotificationChannel,
    listNotificationRule,
    deleteNotificationRule,
    createNotificationRule,
    updateNotificationRule,
    updateNotificationRuleStatus
} from '@/api/monitorManager'
import tip from 'components/ToolTip/index'
export default {
    name: 'notificationRule',
    components: { tip },
    data () {
        return {
            hasPermission: localStorage.role === 'SUPER_ADMIN' || localStorage.role === 'ADMIN',
            list: [],
            loading: false,
            visible: false,
            channelList: [],
            receiverOption: [],
            receiverOptionList: ['Owner', 'Publishers', 'Subscribers'],
            form: {
                title: '',
                id: '',
                name: '',
                notificationChannelId: '',
                notifyContent: '',
                notifyDescription: '',
                notifySubject: '',
                alertPeriod: '',
                notifyUsers: [],
                timeUnit: '',
                enable: false
            },
            pageable: {
                page: 1,
                size: 10,
                total: 0
            },
            tagInput: '',
            tagVisible: false,
            rules: {
                name: [
                    { required: true, message: 'please select name', trigger: 'blur' }
                ],
                type: [
                    { required: true, message: 'please select type', trigger: 'blur' }
                ],
                url: [
                    { required: true, message: 'please select url', trigger: 'blur' }
                ],
                authorization: [
                    { required: true, message: 'please select authorization', trigger: 'blur' }
                ]
            }
        }
    },
    created () {
        this.fetchData()
        this.fetchChannelList()
    },
    methods: {
        handleSizeChange (val) {
            this.pageable.size = val
            this.fetchData()
        },
        save () {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    const notifyUsers = this.form.notifyUsers.concat(this.receiverOption)
                    const { title, id, name, notificationChannelId, notifyContent, notifyDescription, notifySubject, alertPeriod, timeUnit, enable } = this.form
                    const data = { name, notificationChannelId, notifyContent, notifyDescription, notifySubject, alertPeriod, notifyUsers, timeUnit, enable }
                    if (title === 'Create Notification Rule') {
                        this.loading = true
                        createNotificationRule(data).then(response => {
                            this.$message.success('Create success')
                            this.loading = false
                            this.visible = false
                            this.fetchData()
                        }).catch(() => {
                            this.loading = false
                        })
                    } else if (title === 'Edit Notification Rule') {
                        this.loading = true
                        updateNotificationRule(id, data).then(response => {
                            this.$message.success('Update success')
                            this.loading = false
                            this.visible = false
                            this.fetchData()
                        }).catch(() => {
                            this.loading = false
                        })
                    }
                }
            })
        },
        showCreate () {
            this.form.title = 'Create Notification Rule'
            this.form.id = ''
            this.form.name = ''
            this.form.notificationChannelId = ''
            this.form.notifyContent = ''
            this.form.notifyDescription = ''
            this.form.notifySubject = ''
            this.form.alertPeriod = ''
            this.form.notifyUsers = []
            this.form.receiverOption = []
            this.form.timeUnit = 'DAYS'
            this.form.enable = false
            this.visible = true
        },
        showEdit (row) {
            this.form.title = 'Edit Notification Rule'
            this.form.id = row.id
            this.form.name = row.name
            this.form.notificationChannelId = row.notificationChannelId
            this.form.notifyContent = row.notifyContent
            this.form.notifyDescription = row.notifyDescription
            this.form.notifySubject = row.notifySubject
            this.form.alertPeriod = row.alertPeriod
            this.form.notifyUsers = row.notifyUsers.filter(item => {
                return this.receiverOptionList.indexOf(item) === -1
            })
            this.receiverOption = row.notifyUsers.filter(item => {
                return this.receiverOptionList.indexOf(item) > -1
            })
            this.form.timeUnit = row.timeUnit
            this.form.enable = row.enable
            this.visible = true
        },
        changeStatus (row) {
            this.$confirm('This will change the status. Continue?', 'Warning', {
                confirmButtonText: 'Change',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(() => {
                const data = {
                    active: !row.enable
                }
                this.loading = true
                updateNotificationRuleStatus(row.id, data).then(response => {
                    this.loading = false
                    this.fetchData()
                    this.$message.success('Change status success!')
                }).catch(() => {
                    this.loading = false
                })
            }).catch(() => {
                this.$message.info('Change canceled')
            })
        },
        showDelete (id) {
            this.$confirm('This will delete the notification channel. Continue?', 'Warning', {
                confirmButtonText: 'Delete',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(() => {
                deleteNotificationRule(id).then(response => {
                    this.loading = false
                    this.$message.success('Delete success!')
                    this.fetchData()
                }).catch(() => {
                    this.loading = false
                })
            }).catch(() => {
                this.loading = false
                this.$message.info('Delete canceled')
            })
        },
        fetchData () {
            this.loading = true
            listNotificationRule(this.pageable.size, this.pageable.page - 1).then(response => {
                const { content, pageable: { page, size }, total } = response
                this.list = content
                this.pageable.total = total
                this.pageable.page = page + 1
                this.pageable.size = size
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
        },
        fetchChannelList () {
            if (!this.channelList.length) {
                listNotificationChannel().then(response => {
                    this.channelList = response
                })
            }
        },
        handleClose (tag) {
            this.form.notifyUsers.splice(this.form.notifyUsers.indexOf(tag), 1)
        },
        showInput () {
            this.tagVisible = true
            this.$nextTick(_ => {
                this.$refs.saveTagInput.$refs.input.focus()
            })
        },
        handleInputConfirm () {
            var inputTagValue = this.tagInput
            if (inputTagValue) {
                if (this.form.notifyUsers.indexOf(inputTagValue) === -1) {
                    this.form.notifyUsers.push(inputTagValue)
                } else {
                    this.$message({
                        type: 'warning',
                        message: 'Duplicated value'
                    })
                }
            }
            this.tagVisible = false
            this.tagInput = ''
        }
    }
}
</script>
<style>
.number-with-select .zm-input__inner {
    border-radius: 8px 0 0 8px;
}
.select-with-number {
    width: 110px;
}
.select-with-number .zm-select-input {
    border-radius: 0 8px 8px 0;
}
.select-with-number.zm-select {
    border-radius: 0 8px 8px 0;
}
.input-tag {
  margin-right: 10px;
  padding:  0 20px 0 10px;
}
.input-new-tag.zm-input {
  width: 200px;
  vertical-align: baseline;
}
.button-new-tag {
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
}
.input-new-tag {
    width: 90px;
    vertical-align: bottom;
}
</style>
